const ProjectActionLink = ({ url, linkText }) => {
    return (
        <a
            href={url}
            className="project-action-link"
            target="_blank"
            rel="noreferrer"
        >
            {linkText}
        </a>
    )
}

export default ProjectActionLink;